module.exports = __webpack_public_path__ + "img/cellphone-case.6853fdf8.png";